module.exports = __webpack_public_path__ + "img/escassez.4821f82a.svg";